import { sendEvent } from '../../../configs/firebase'

/** Parâmetros de contexto comuns aos eventos da agenda inteligente. */
export type SmartAgendaContextParams = {
  professional_id?: string
  patterns_count?: number
  /** Dias da semana com faixa (1=seg … 7=dom), ex.: "1,3,5" */
  days_of_week?: string
  time_ranges_count?: number
  date_range_weeks?: number
  agendas_created_count?: number
  has_conflict?: boolean
}

function withContext(
  ctx: SmartAgendaContextParams
): Record<string, string | number | boolean> {
  return {
    professional_id: ctx.professional_id ?? '',
    patterns_count: ctx.patterns_count ?? 0,
    days_of_week: ctx.days_of_week ?? '',
    time_ranges_count: ctx.time_ranges_count ?? 0,
    date_range_weeks: ctx.date_range_weeks ?? 0,
    agendas_created_count: ctx.agendas_created_count ?? 0,
    has_conflict: Boolean(ctx.has_conflict),
  }
}

const smartAgendaAnalytics = {
  trackPatternStart(ctx: SmartAgendaContextParams = {}): void {
    sendEvent('agenda_pattern_start', withContext(ctx))
  },

  trackPatternDefined(ctx: SmartAgendaContextParams = {}): void {
    sendEvent('agenda_pattern_defined', withContext(ctx))
  },

  trackBulkDateRangeSelected(ctx: SmartAgendaContextParams = {}): void {
    sendEvent('agenda_bulk_date_range_selected', withContext(ctx))
  },

  trackBulkPreviewViewed(ctx: SmartAgendaContextParams = {}): void {
    sendEvent('agenda_bulk_preview_viewed', withContext(ctx))
  },

  trackBulkConfirmed(ctx: SmartAgendaContextParams = {}): void {
    sendEvent('agenda_bulk_confirmed', withContext(ctx))
  },

  trackBulkSuccess(ctx: SmartAgendaContextParams = {}): void {
    sendEvent('agenda_bulk_success', withContext(ctx))
  },

  trackBulkFailed(ctx: SmartAgendaContextParams = {}): void {
    sendEvent('agenda_bulk_failed', withContext(ctx))
  },
}

export default smartAgendaAnalytics
